import React from 'react';
import {Body, Section, Div1, Div2} from './afiliadosStyle';
import imagenes from '../../Assets/imagenes';
import FormAfiliados  from './FormAfiliados';

const Afiliados = () => {
    return (
        <Body>
            <Section>
                <Div1>
                    <img src={imagenes.evento} alt="" />
                </Div1> 
                <Div2>
                    <FormAfiliados/>
                </Div2>
            </Section>
        </Body>
    )
}
export default Afiliados;